import { Input } from "antd";
import "./styles.scss";

const { TextArea } = Input;

export default function DBTextArea(props) {
    return (
        <div className="db-textarea">
            <TextArea className="db-textarea" {...props} />
        </div>
    );
}
